import React from 'react';
import './style.scss';

const TimeDescription = ({ measure, timePeriod }) => {
	return (
		<div className="insights-time-title__container">
			<h3 className="insights-time-title__measure">{measure}</h3>
			<p className="insights-time-title__period">{timePeriod}</p>
		</div>
	);
};

export default TimeDescription;
